export default function PresentationVideo() {
  return (
    <section
      id="presentation"
      aria-label="Vidéo de présentation"
      className="relative w-full overflow-hidden py-16 sm:py-20 lg:py-24 bg-[#fbf9f4]"
    >
      <div className="relative z-10 flex justify-center px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center">
          {/* Titre dans le même style que les autres grands titres */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight leading-none mb-10 sm:mb-14 text-gray-800 text-center">
            DÉCOUVREZ LE CONCEPT
          </h2>

          {/* Vidéo verticale 9:16, jamais étirée ni recadrée */}
          <div className="relative rounded-[1.6rem] sm:rounded-[2rem] overflow-hidden bg-[#1a1a1a]">
            <video
              className="block w-[86vw] max-w-[320px] h-auto aspect-[9/16] object-contain bg-black"
              src="https://storage.helloreaddy.io/project_files/d8db5950-dd7c-40d9-b2de-72ddcdf21388/37fb57e2-6ac9-456e-8617-a003e71eae9d_Prsentation.mp4"
              poster="https://storage.helloreaddy.io/project_files/d8db5950-dd7c-40d9-b2de-72ddcdf21388/474deeff-2239-4220-8083-55122d677892_compressed_lio-et-lou.webp"
              controls
              playsInline
              preload="metadata"
              style={{ maxHeight: '78dvh' }}
            />
          </div>

          {/* CTA vers le formulaire de devis */}
          <a
            href="#devis"
            className="mt-10 sm:mt-12 inline-block bg-[#00A8B5] hover:bg-[#008f9b] text-black font-semibold px-12 py-4 rounded-md transition-all duration-300 whitespace-nowrap text-lg cursor-pointer"
          >
            DEMANDER UNE OFFRE →
          </a>
        </div>
      </div>
    </section>
  );
}